import {
  UpdateTopbarExpandedMenuAction,
  ClearTopbarExpandedMenuAction,
  UpdateTopbarButtomMenuTriggeredClickAction,
  UpdateTopbarExpandedMenuAlignmentAction,
  UpdateTopbarSiteNavRenderedAction,
} from './actions';
import { TopbarExpandedMenu, TopbarDropdownAlignment } from './constants';

export const updateTopBarExpendedMenu = (
  menu: TopbarExpandedMenu
): UpdateTopbarExpandedMenuAction => ({
  type: 'UPDATE_TOPBAR_EXPANDED_MENU',
  menu,
});

export const clearTopBarExpendedMenu = (): ClearTopbarExpandedMenuAction => ({
  type: 'CLEAR_TOPBAR_EXPANDED_MENU',
});

export const updateTopBarButtonMenuTriggeredClick = (
  isTriggeredClick: boolean
): UpdateTopbarButtomMenuTriggeredClickAction => ({
  type: 'UPDATE_TOPBAR_BUTTON_MENU_TRIGGERED_CLICK',
  isTriggeredClick,
});

export const updateTopBarExpendedMenuAlignment = (
  alignment: TopbarDropdownAlignment
): UpdateTopbarExpandedMenuAlignmentAction => ({
  type: 'UPDATE_TOPBAR_EXPANDED_MENU_ALIGNMENT',
  alignment,
});

export const updateTopBarSiteNavRendered = (
  rendered: boolean
): UpdateTopbarSiteNavRenderedAction => ({
  type: 'UPDATE_TOPBAR_SITE_NAV_RENDERED',
  rendered,
});
